import { render } from "./Appliances.vue?vue&type=template&id=4b7595d7&scoped=true"
import script from "./Appliances.vue?vue&type=script&lang=js"
export * from "./Appliances.vue?vue&type=script&lang=js"

import "./Appliances.vue?vue&type=style&index=0&id=4b7595d7&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7595d7"]])

export default __exports__